type RefreshButtonProps = {
  label?: string
  className?: string
}

export default function RefreshButton({
  label = 'Refresh Feed',
  className
}: RefreshButtonProps) {
  return (
    <button
      type="button"
      onClick={() => window.location.reload()}
      className={className}
      aria-label={label}>
      {label}
    </button>
  )
}
